import { apiWidget, api, web } from "apiConnections";

const setCustomHeader = (header: string, value: string) => {
    if (header && value) {
        web.defaults.headers.common[header] = value;
        api.defaults.headers.common[header] = value;
        apiWidget.defaults.headers.common[header] = value;
    } else if (!value) {
        delete web.defaults.headers.common[header];
        delete api.defaults.headers.common[header];
        delete apiWidget.defaults.headers.common[header];
    }
};

export default setCustomHeader;
